// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".google_map_-aLI4{margin:0 0 2.4rem}@media only screen and (min-width:768px){.google_map_-aLI4{margin:0}}@media only screen and (min-width:1264px){.google_map_-aLI4{display:block;margin:0 0 2.4rem}}.google_map_-aLI4 a{background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:.4rem;display:block;overflow:hidden;position:relative}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"google_map": "google_map_-aLI4"
};
module.exports = ___CSS_LOADER_EXPORT___;
